import {
  IPagedResults,
  RedactedScheduledVendorCollectionResponse,
  ScheduledVendorCollectionFilterParams,
} from '@mesa-labs/mesa-api/dist/types';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { prepareHeaders, useInvoiceApi } from './api';

export const collectionsApi = createApi({
  reducerPath: 'collectionsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: CONFIG.api.invoiceUrl,
    prepareHeaders,
  }),
  tagTypes: ['Collections'],
  endpoints: (build) => ({
    getScheduledVendorCollection: build.query<RedactedScheduledVendorCollectionResponse | undefined, { identifier: string }>({
      async queryFn(params, thunkApi) {
        const externalInvoiceApi = useInvoiceApi(thunkApi.dispatch);
        const data = await externalInvoiceApi.getScheduledVendorCollection<RedactedScheduledVendorCollectionResponse>(params.identifier);

        return { data };
      },
    }),
    getAllScheduledVendorCollections: build.query<IPagedResults<RedactedScheduledVendorCollectionResponse>, ScheduledVendorCollectionFilterParams>({
      async queryFn(params, thunkApi) {
        const externalInvoiceApi = useInvoiceApi(thunkApi.dispatch);
        const data = await externalInvoiceApi.getAllScheduledVendorCollections<RedactedScheduledVendorCollectionResponse>(params);

        return { data };
      },
      providesTags: ['Collections'],
    }),
  }),
});

export const exportScheduledVendorCollections = async (filters: Partial<ScheduledVendorCollectionFilterParams>): Promise<BlobPart> => {
  const params = new URLSearchParams();

  const url = new URL(`${CONFIG.api.invoiceUrl}/scheduled-vendor-collections/csv/export?${params.toString()}`);

  Object.entries(filters).forEach(([k, v]) => {
    if (v) {
      if (Array.isArray(v)) {
        (v as Array<any>).forEach((arrayValue) => {
          url.searchParams.append(k, arrayValue);
        });
      } else {
        url.searchParams.append(k, v.toString());
      }
    }
  });
  const headers = await prepareHeaders(new Headers());
  const response = await fetch(url.href, {
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers,
  });

  return await response.blob();
};

export const {
  useGetScheduledVendorCollectionQuery,
  useGetAllScheduledVendorCollectionsQuery,
} = collectionsApi;
